import { render, staticRenderFns } from "./CanvasCommunication.vue?vue&type=template&id=e41a6faa&"
import script from "./CanvasCommunication.vue?vue&type=script&lang=js&"
export * from "./CanvasCommunication.vue?vue&type=script&lang=js&"
import style0 from "./CanvasCommunication.vue?vue&type=style&index=0&id=e41a6faa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports